import { useState } from 'react'
import { Button, Checkbox, Modal } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import {
    DONT_SHOW_ANNOTATION_INTRODUCTION,
    setLocalStorageItem,
} from '@Builder/QuoteDetailPage/logic'
import { useLocation } from 'react-router-dom'

import Box from '~/core/Box'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import icons from '~/apps/consumer/icons'

import {
    IM_DFM_TYPE,
    MODAL_MSG,
    TWO_D_DRAWING_TYPE,
    LTO_ANNOTATION_MODAL,
} from './constants'

type PropsType = {
    onClose: () => void
    type?: typeof IM_DFM_TYPE | typeof TWO_D_DRAWING_TYPE
    userId: number
}

const PdfAnnotationModal = (props: PropsType) => {
    const { onClose, type, userId } = props

    const { pathname } = useLocation()
    const onLTOPage = pathname.includes('/optimizations')

    const [checkboxStatus, setCheckboxStatus] = useState(false)

    let modalMsg = onLTOPage
        ? MODAL_MSG[LTO_ANNOTATION_MODAL]
        : MODAL_MSG[TWO_D_DRAWING_TYPE]

    if (type === IM_DFM_TYPE) {
        modalMsg = MODAL_MSG[IM_DFM_TYPE]
    }

    const handleOnCloseModal = () => {
        if (checkboxStatus) {
            setLocalStorageItem(
                `${DONT_SHOW_ANNOTATION_INTRODUCTION}-${userId}`,
                checkboxStatus,
            )
        }
        onClose()
    }

    return (
        <Modal
            bodyStyle={{ padding: '16px' }}
            closable={false}
            footer={[
                <Checkbox
                    key="showMeBtnSubmit"
                    onChange={(evt: CheckboxChangeEvent) => {
                        setCheckboxStatus(evt.target.checked)
                    }}
                    style={{ float: 'left', margin: '4px 0' }}
                >
                    Don't show me again
                </Checkbox>,
                <Button
                    data-test-target="start-annotating"
                    key="submit"
                    name="start-annotating"
                    onClick={handleOnCloseModal}
                    type="primary"
                >
                    {modalMsg.buttonTxt}
                </Button>,
            ]}
            maskClosable
            title={
                <Text
                    color="blackAlpha65"
                    fontSize="16px"
                    style={{ marginLeft: '-8px' }}
                >
                    {modalMsg.title}
                </Text>
            }
            visible={true}
        >
            <Box marginBottom="16px">{modalMsg.body1}</Box>
            <Box marginBottom="16px">{modalMsg.body2}</Box>
            <Box border={`1px solid ${getColor('blackAlpha15')}`}>
                <img
                    height="auto"
                    src={icons.imDfmAnnotationsGif}
                    style={{ maxWidth: '100%' }}
                />
            </Box>
        </Modal>
    )
}

export default PdfAnnotationModal
